import { FormFieldFG, FormFieldTypeFG, CustomFormFieldFG, SelectFormFieldFG } from '@hwm/ui-lib';
import { Trans, t } from '@lingui/macro';
import { Typography } from '@material-ui/core';
import { SearchTypeOptionsFn, SortColumnOptionsFn, SortOrderOptionsFn } from '@shared/models';

export const siteListPreferencesFieldsConfiguration: FormFieldFG[] = [
  {
    label: '',
    property: 'siteListTitle',
    type: FormFieldTypeFG.CustomField,
    renderer: () => {
      return (
        <Typography>
          <Trans>Site List</Trans>
        </Typography>
      );
    },
  } as CustomFormFieldFG,
  {
    label: '',
    property: 'siteListSearchType',
    type: FormFieldTypeFG.Select,
    availableValues: Object.entries(SearchTypeOptionsFn()).map(([value, label]) => ({
      label,
      value,
    })),
    returnKeyOnly: true,
    innerSelectLabel: t`Search Type`,
    containerClasses: 'mb-4',
  } as SelectFormFieldFG,
  {
    label: '',
    property: 'siteListColumnSort',
    type: FormFieldTypeFG.Select,
    availableValues: Object.entries(SortColumnOptionsFn()).map(([value, label]) => ({
      label,
      value,
    })),
    returnKeyOnly: true,
    innerSelectLabel: t`Sort by`,
    containerClasses: 'mb-4',
  } as SelectFormFieldFG,
  {
    label: '',
    property: 'siteListSortOrder',
    type: FormFieldTypeFG.Select,
    availableValues: Object.entries(SortOrderOptionsFn()).map(([value, label]) => ({
      label,
      value,
    })),
    returnKeyOnly: true,
    innerSelectLabel: t`Order`,
    containerClasses: 'mb-2',
  } as SelectFormFieldFG,
];
